import React from "react";
import _ from "lodash";
import {
  DeviceMobileOutlined,
  CodeBlockOutlined,
  EmailOutlined,
} from "@toddle-edu/ds-icons";

export const formatErrorMessage = message => {
  if (!message) return "";
  return message
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/^\w/, c => c.toUpperCase());
};

export const TABS = {
  ORG_LEVEL_SETTINGS: "ORG_LEVEL_SETTINGS",
  ROLE_LEVEL_SETTINGS: "ROLE_LEVEL_SETTINGS",
};

export const METHOD_CONFIG = {
  TOTP: {
    icon: <DeviceMobileOutlined size="xx-small" />,
    labelKey: "common:authenticator_app",
    subtitleKey: "common:authenticator_app_subtitle",
  },
  EMAIL_OTP: {
    icon: <EmailOutlined size="xx-small" />,
    labelKey: "common:otp_verification",
    subtitleKey: "common:otp_verification_subtitle",
  },
  BACKUP_CODE: {
    icon: <CodeBlockOutlined size="xx-small" />,
    labelKey: "common:backup_code",
    subtitleKey: "common:backup_code_subtitle",
  },
};

export const ALLOWED_MFA_METHODS = ["TOTP", "EMAIL_OTP"];

export const getMfaMethodOptions = (methods = [], t) =>
  _.map(methods, m => {
    const config = _.get(METHOD_CONFIG, m, {});
    return {
      label: _.get(config, "labelKey") ? t(config.labelKey) : m,
      value: m,
      subtitle: _.get(config, "subtitleKey") ? t(config.subtitleKey) : "",
      icon: _.get(config, "icon"),
    };
  });
